import { AlertItem } from '@/components/ui/feedback/alert-item/AlertItem';

export const AlertBlock = ({ data }) => {
  return <AlertItem text={data?.fields?.text} />;
};
